<template>
  <AntProvider :configProviderProps="{ locale: locale }" :theme="currentTheme">
    <slot />
  </AntProvider>
</template>

<script lang="ts" setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';

import { AntProvider } from '.';

const area = getEnv('area') as 'CN' | 'US';
const locale = ['CN'].includes(area) ? zhCN : enUS;

const currentTheme = useTheme();
currentTheme.value = 'light';
// currentTheme.value = 'light'
</script>
